import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, nextTick, onMounted } from 'vue';
import { store } from '@/store';
import QueryParamService, { QueryParams } from '@/core/query-params.service';
import { StorageService } from '@/core';
import { watchRelativeUrl } from '@/core/route.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionItem',
  props: {
    title: { default: '' },
    panelClass: { default: '' },
    contentClass: { default: '' },
    persistState: { type: Boolean, default: true },
    defaultExpanded: { type: Boolean, default: false },
    id: null,
    transition: null,
    watchRouteChange: { type: Boolean, default: true },
    prerenderContent: { type: Boolean },
    expanded: { type: [Boolean, null] }
  },
  emits: ["expandedChange"],
  setup(__props: any, { emit }: { emit: ({(e: 'expandedChange', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, panelClass: any, contentClass: any, persistState: boolean, defaultExpanded: boolean, id?: string | undefined, transition?: string | undefined, watchRouteChange: boolean, prerenderContent?: boolean, expanded?: boolean | undefined }



const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const isExpanded = ref<boolean>(false);

const LocalStorageKey = 'prof-accordions';

// Sync expanded state with prop
watch(() => props.expanded, (val) => {
    if (val !== undefined) isExpanded.value = val;
});

// Persist state and handle route/query/localStorage as before
watchRelativeUrl(onRouteChange);
function onRouteChange(route, oldRoute) {
    if (props.watchRouteChange && route && oldRoute && route.path === oldRoute.path) {
        setExpandedFromQuery();
    }
}

onMounted(() => {
    let defaultState = props.defaultExpanded;
    const isAnyQuerySet = QueryParamService.getParam(QueryParams.AccordionState);

    let storedValues = StorageService.getItemAs<{key: string, value: boolean}[]>(LocalStorageKey) || [];
    const isAnyValueStored = storedValues.length > 0;

    if (isAnyQuerySet) {
        defaultState = isThisQuerySet;
    } else if (isAnyValueStored) {
        const state = storedValues.find(x => x.key === props.id);
        if (state !== undefined) {
            defaultState = state.value;
        }
    }
    // We use nextTick here to prevent setting query or localstorage immediately
    // If a previous AccordionItem toggled state immediately isAnyQuerySet and isAnyValuesStored
    // would be different for the following AccordionItems.
    nextTick(() => {
        isExpanded.value = defaultState;
    });
});

function setExpandedFromQuery():void {
    const state = QueryParamService.hasQueryParamValue(QueryParams.AccordionState, props.id);
    isExpanded.value = state;
}

function onToggle(event: Event) {
    isExpanded.value = (event.target as HTMLDetailsElement).open;
    persistStateInQuery(isExpanded.value);
    persistStateInLocalStorage(isExpanded.value);
    emit('expandedChange', isExpanded.value);
}

function persistStateInQuery(state:boolean): void {
    if (props.persistState && props.id) {
        if (state) {
            QueryParamService.setQueryParamValue(QueryParams.AccordionState, props.id);
        } else {
            QueryParamService.removeQueryParamValue(QueryParams.AccordionState, props.id);
        }
    }
}

function persistStateInLocalStorage(state:boolean): void {
    if (props.persistState && props.id) {
        let values = StorageService.getItemAs<{key: string, value: boolean}[]>(LocalStorageKey) || [];
        const index = values.findIndex(x => x.key === props.id);

        if (index === -1) {
            values.push({ key: props.id, value: state });
        } else {
            values[index].value = state;
        }

        StorageService.setItemAs<{key: string, value: boolean}[]>(LocalStorageKey, values);
    }
}

return { __sfc: true,props, emit, theme, isExpanded, LocalStorageKey, onRouteChange, setExpandedFromQuery, onToggle, persistStateInQuery, persistStateInLocalStorage }
}

})